﻿import { SecurityCode } from "../../components/securityCode";
import {
  sendActivationCode,
  validateActivationCode,
} from "../../api/accountWorker";

let registerSecurityCode;
let registerEmail;

$(() => {
  registerSecurityCode = new SecurityCode($("#securityCode"));

  $("#registerCodeStep").on("show", () => {
    registerEmail = $("#Email").val();

    $("#registerCodeEmail").text(registerEmail);

    sendRegisterCode();
  });

  $("#securityCodeValidate", registerSecurityCode).on("click", () => {
    validateActivationCode();
  });

  registerSecurityCode.element.on("send", sendRegisterCode);
});

function sendRegisterCode() {
  registerSecurityCode.resendButton.attr("disabled", true);

  sendActivationCode(registerEmail)
    .done((result) => {
      registerSecurityCode.startTimer();
    })
    .fail((x) => {
      console.error("Error sendActivationCode()");
      if (x.responseJSON.code == "429") {
        registerSecurityCode.startTimer();
        registerSecurityCode.setTimerVisibility(true);
      }
    })
    .always(() => {
      registerSecurityCode.resendButton.removeAttr("disabled");
    });
}

window.validateSecurityCode = () => {
  if (!registerSecurityCode.code.isFilled()) {
    registerSecurityCode.code.setValidation(false);
    return;
  }

  const validateCodeButton = $("#validateCode");
  validateCodeButton.attr("disabled", true);
  validateActivationCode(registerEmail, registerSecurityCode.code.getValue())
    .done(() => {
      nextStep();
    })
    .fail((jqXHR) => {
      if (jqXHR.status === 400 || jqXHR.status === 409) {
        registerSecurityCode.code.setValidation(false);
      } else {
        console.error("Error validateActivationCode()");
      }
    })
    .always(() => {
      validateCodeButton.removeAttr("disabled");
    });
};
